import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ForgetPasswordStep, State } from './types';
import { confirmResetPasswordThunk, resetPasswordThunk } from './thunks';

const initialState: State = {
    step: 'Username',
    fetchStatus: 'Idle',
    username: '',
    newPassword: '',
    OTP: null,
};

export const forgetPasswordSlice = createSlice({
    name: 'forgetPassword',
    initialState,
    reducers: {
        setForgetPasswordStep: (state, action: PayloadAction<ForgetPasswordStep>) => {
            state.step = action.payload;
        },
        setUsername: (state, action: PayloadAction<string>) => {
            state.username = action.payload;
        },
        setOTP: (state, action: PayloadAction<string | null>) => {
            state.OTP = action.payload;
        },
        setNewPassword: (state, action: PayloadAction<string>) => {
            state.newPassword = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(resetPasswordThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(resetPasswordThunk.fulfilled, (state) => {
                state.step = 'verify';
                state.fetchStatus = 'Idle';
            })
            .addCase(resetPasswordThunk.rejected, (state) => {
                state.fetchStatus = 'Idle';
            })
            .addCase(confirmResetPasswordThunk.pending, (state) => {
                state.fetchStatus = 'Pending';
            })
            .addCase(confirmResetPasswordThunk.fulfilled, (state) => {
                state.step = 'Approval';
                state.fetchStatus = 'Idle';
                state.username = '';
                state.newPassword = '';
            })
            .addCase(confirmResetPasswordThunk.rejected, (state) => {
                state.OTP = null;
                state.step = 'verify';
                state.fetchStatus = 'Idle';
            })
    }
});

export const {
    setOTP,
    setUsername,
    setNewPassword,
    setForgetPasswordStep,
} = forgetPasswordSlice.actions;